import { createContext, FC, ReactNode, useContext } from "react"
import { I_city, I_type, I_tab, I_hub, I_tabsDic } from "./types"
import { I_usePopup } from "./../../components/aio/aio-popup"
import Apis from "./apis"
import { useRoles } from "./use-roles"
import { useGrid } from "./grid-filter-hook"


export type I_RootFreelancerContext = {
    popup:I_usePopup,
    cities:I_city[],
    options:any
    apis:Apis,
    currenthub: I_hub, 
}
const RootFreelancerContext = createContext<I_RootFreelancerContext>({} as any)
export const RootFreelancerProvider:FC<{value:I_RootFreelancerContext,children:ReactNode}> = ({value,children})=>{
    return (
        <RootFreelancerContext.Provider value={value}>
            {children}
        </RootFreelancerContext.Provider>
    )
}
export const useRootFreelancerProvider = ()=>useContext(RootFreelancerContext)


export type I_Context = {
    openAddModal:()=>void,
    openEditModal:(id:number)=>void,
    gridHook:ReturnType<typeof useGrid>,
    tabsDic: I_tabsDic,
    typesDic: { [key in I_type]: { text: string, tabs: I_tab[],value:number } },
    typeOptions:{text:string,value:I_type}[],
    rolesHook:ReturnType<typeof useRoles>,
    inputCls:string
}
const Context = createContext<I_Context>({} as any)
export const FreelancerProvider:FC<{value:I_Context,children:ReactNode}> = ({value,children})=>{
    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    )
}
export const useFreelancerProvider = ()=>useContext(Context)
const AddEmployeeContext = createContext({} as any)

export {AddEmployeeContext}
